import React from 'react';
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './App.css';

// Components
import Layout from './components/Layout';
import LayoutPublic from './components/LayoutPublic';
import Main from './components/Main2';
import Login from './components/Login';
import AdminLogin from './components/AdminLogin';
import Verify from './components/Verify';
import Information from './components/Information';
import MapOffline from './components/MapOffline';
import CreditUser from './components/CreditUser';
import PasswordRecovery from './components/PasswordRecovery';
import PasswordRecoveryChange from './components/PasswordRecoveryChange';
import PrivecyCode from './components/PrivecyCode';
import NotFound from './components/NotFound';
import { ToastProvider } from './Services/ToastContext';
import  VideoUploadPage  from './components/VideoUploadPage';

const App = () => {
  return (
    <>
      <ToastProvider>
        <ToastContainer
          bodyClassName={() => "myToastClass"}
          position="bottom-center"
          autoClose={3000}
          hideProgressBar={true}
          rtl={true}
        />

        <Routes>
          <Route element={<LayoutPublic />}>
            <Route path="/login" element={<Login />} />
            <Route path="/PasswordRecovery" element={<PasswordRecovery />} />
            <Route path="/PasswordRecoveryChange" element={<PasswordRecoveryChange />} />
          </Route>

          <Route path="/AdminLogin" element={<AdminLogin />} />
          <Route path="/verify" element={<Verify />} />


          <Route path="/PrivecyCode" element={<PrivecyCode />} />
          <Route path="/information" element={<Information />} />

          <Route path='/map' element={<MapOffline />} />
          <Route path="/map/:lat/:lng" element={<MapOffline />} />
          <Route path="/map/:coords" element={<MapOffline />} />
          <Route path="/CreditUser/:seriall" element={<CreditUser />} />

          <Route element={<Layout />}>
            <Route index element={<Main />} /> {/* مسیر اصلی / */}
            <Route path='/main' element={<Main />} />
          </Route>

          <Route path="/VideoUpload" element={<VideoUploadPage />} />

          {/* مسیر 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ToastProvider>
    </>
  );
};

export default App;
